import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";


export const addAccount = catchAsync(async (body) => {
    const { data } = await axiosInstance.post(
      `/api/resource/Bank Account`,
      body
    );
    return data;
  });
export const updateAccount = catchAsync(async (body, editId) => {
    const { data } = await axiosInstance.put(
      `/api/resource/Bank Account/${editId}`,
      body
    );
    return data;
  });

  export const getBankAccount = catchAsync(async (lang) => {
    const { data } = await axiosInstance.get(
        `/api/resource/Bank Account?fields=["account_name","is_company_account","account","bank","bank_account_no","name","branch_code"]`
    );
    return data;
  });
  export const getBankAccountDetails = catchAsync(async (id) => {
    const { data } = await axiosInstance.get(
      `/api/resource/Bank Account/${id}`
    );
    return data;
  });
  export const deleteAccount = catchAsync(async (id) => {
    const { data } = await axiosInstance.delete(
      `/api/resource/Bank Account/${id}`
    );
    return data;
  });